module.exports = __webpack_public_path__ + "static/media/Shriners Hospitals for Children.fb6ac9ad.png";